/**
 * Beskär en uppladdad bild till en kvadrat och skalar ner den innan den skickas
 * till servern. Profilbilderna lagras som BLOB i D1, så de behöver vara små.
 */
export async function fileToAvatarBlob(file: File, size = 320): Promise<Blob> {
  if (!file.type.startsWith("image/")) {
    throw new Error("Filen är inte en bild.");
  }

  const bitmap = await createImageBitmap(file);
  const side = Math.min(bitmap.width, bitmap.height);

  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext("2d");
  if (!context) throw new Error("Kunde inte bearbeta bilden.");

  context.drawImage(
    bitmap,
    (bitmap.width - side) / 2,
    (bitmap.height - side) / 2,
    side,
    side,
    0,
    0,
    size,
    size,
  );
  bitmap.close();

  return toBlob(canvas);
}

/** WebP där det stöds, annars JPEG. */
function toBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) return resolve(blob);
        canvas.toBlob(
          (fallback) =>
            fallback ? resolve(fallback) : reject(new Error("Kunde inte spara bilden.")),
          "image/jpeg",
          0.82,
        );
      },
      "image/webp",
      0.85,
    );
  });
}
